// The Metadata tab of a dataset (/datasets/:id/metadata): the dataset's additional fields
// (N6, 2026-10-14: src/forms/FieldValuesForm.jsx on GET/PUT /api/datasets/{id}/field-values —
// the fixed metadata form is gone; name, description and kind are edited in the page header),
// plus the schema.org JSON-LD and RO-Crate downloads, which carry the field values as
// `additionalProperty`. Publishing is the department's repository, not unio (N1).
//
// Props (see DatasetPage.jsx): { dataset, files, canEdit, reloadDataset, reloadFiles }
import { useState } from "react";
import { api } from "../../api";
import { ErrorNote } from "../../components/Feedback";
import RoCrateButton from "../../components/RoCrateButton";
import { Btn } from "../../components/Shared";
import FieldValuesForm from "../../forms/FieldValuesForm";
import { editedBy } from "./author";

export default function MetadataTab({ dataset, canEdit, reloadDataset }) {
  const [downloadError, setDownloadError] = useState(null);
  const downloadJsonLd = () => {
    setDownloadError(null);
    api.download(`/datasets/${dataset.id}/metadata.jsonld`, `dataset-${dataset.id}.jsonld`).catch(setDownloadError);
  };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, flexWrap: "wrap", marginBottom: 14 }}>
        <p style={{ margin: 0, fontSize: 13, color: "#4b5563", maxWidth: 640 }}>
          Name, description and kind are edited above; the fields below are the ones this dataset's
          project uses for its datasets.
          {!canEdit && ` Read-only: ${editedBy(dataset.study_created_by)}.`}
        </p>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-start" }}>
          <Btn variant="secondary" onClick={downloadJsonLd}>Download JSON-LD</Btn>
          <RoCrateButton kind="datasets" id={dataset.id} filename={`dataset-${dataset.id}.zip`} />
        </div>
      </div>
      <ErrorNote error={downloadError} />
      <FieldValuesForm key={dataset.id} path={`/datasets/${dataset.id}/field-values`} canEdit={canEdit}
                       title="Dataset fields" formLabel={`Fields of ${dataset.name}`}
                       projectId={dataset.project_id} onSaved={reloadDataset} />
    </div>
  );
}
